import indexMixin from "../mixins/index";
export default {
  name: "res-switch",
  mixins: [indexMixin],

  data() {
    return {
      dataModel: this.value
    };
  },

  props: {
    value: {
      type: [Boolean, String, Number]
    },
    activeText: {
      type: String,
      default: ""
    },
    inactiveText: {
      type: String,
      default: ""
    },
    activeValue: {
      type: [Boolean, String, Number],
      default: true
    },
    inactiveValue: {
      type: [Boolean, String, Number],
      default: false
    }
  },
  computed: {
    valueToLabel() {
      if (this.dataModel === this.activeValue) {
        // 没有text则展示value
        return this.activeText || this.activeValue;
      }

      if (this.dataModel === this.inactiveValue) {
        return this.inactiveText || this.inactiveValue;
      }

      return "";
    }

  },
  watch: {
    dataModel: {
      handler(val) {
        if (val !== this.activeValue && val !== this.inactiveValue) {
          // 默认值是true/false,当有自定义value时，先修改默认值为符合自定义的value
          if (val === true || val === false) {
            this.dataModel = val ? this.activeValue : this.inactiveValue;
          } else {
            // 当初始值不等于自定义值中的任一个，默认展示关闭状态
            this.dataModel = this.inactiveValue;
          }
        }

        this.$emit("input", this.dataModel);
      },

      immediate: true
    },

    value(val) {
      this.dataModel = val;
    }

  }
};